@if (showNotifications$ | async) {
  <div
  class="square-pointer"></div>
}
@if (showNotifications$ | async) {
  <div
    class="notification-bar">
    <!-- Header -->
    <div
      class="header"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px">
        <div class="notifications-label">{{ 'NOTIFICATIONS.NOTIFICATIONS' | translate }}</div>
        <div>
          <topo-color-count-pill
            colorCode="#e64980"
          [count]="(notifications$ | async)?.length ?? 0"></topo-color-count-pill>
        </div>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="close-button"
          (click)="closeNotificationsClick()">
          <span><i class="icon icon-small_close-X"></i></span>
        </div>
      </div>
    </div>
    <!-- Action bar -->
    <div class="action-bar">
      <button
        fxLayout="row"
        fxLayoutAlign="center center"
        class="button is-ghost is-small"
        (click)="clearAllNotificationsClick()">
        <span style="position: relative; top: 3px; margin-right: 8px"><i class="icon icon-small_close-X"></i></span>
        <span>{{ 'NOTIFICATIONS.CLEAR-ALL' | translate }}</span>
      </button>
    </div>
    <!-- Messages area -->
    <div class="notifications-container">
      @let isOnMap = isOnMap$ | async;
      @for (notification of notifications$ | async; track notification.uId; let last = $last) {
        <topo-notification-display
          [notification]="notification"
          [showBorder]="!last"
          [canZoomToDocument]="isOnMap" />
      }
      <div class="spacer">&nbsp;</div>
    </div>
  </div>
}
